import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'

import Styles from './BillingCycleFilter.module.scss'

type Props = {
  activeFilter: 'paid' | 'unpaid' | 'unreceived'
  hasPaidCycles: boolean
  hasUnpaidCycles: boolean
  hasUnreceivedCycles: boolean
  onFilterChange: (filter: 'paid' | 'unpaid' | 'unreceived') => void
  noTopPadding?: boolean
}

const BillingCycleFilter = ({
  activeFilter,
  hasPaidCycles,
  hasUnpaidCycles,
  hasUnreceivedCycles,
  onFilterChange,
  noTopPadding = false
}: Props) => {
  const { t } = useTranslation()

  const getButtonClass = (isActive: boolean) =>
    isActive ? Styles.activeFilterButton : Styles.inactiveFilterButton
  const getButtonVariant = (isActive: boolean) =>
    isActive ? 'branded' : 'transparentOutlined'

  return (
    <div
      className={clsx(Styles.card, {
        [Styles.cardNoTopPadding]: noTopPadding
      })}
      data-testid="billing-cycle-filter">
      <Button
        shape="rounded"
        size="small"
        variant={getButtonVariant(activeFilter === 'unpaid')}
        className={clsx(
          Styles.filterButton,
          getButtonClass(activeFilter === 'unpaid')
        )}
        onClick={() => {
          onFilterChange('unpaid')
        }}
        disabled={!hasUnpaidCycles}>
        {t('billing.cycle-list.title-unpaid')}
      </Button>
      <Button
        shape="rounded"
        size="small"
        variant={getButtonVariant(activeFilter === 'unreceived')}
        className={clsx(
          Styles.filterButton,
          getButtonClass(activeFilter === 'unreceived')
        )}
        onClick={() => {
          onFilterChange('unreceived')
        }}
        disabled={!hasUnreceivedCycles}>
        {t('billing.cycle-list.title-unreceived')}
      </Button>
      <Button
        shape="rounded"
        size="small"
        variant={getButtonVariant(activeFilter === 'paid')}
        className={clsx(
          Styles.filterButton,
          getButtonClass(activeFilter === 'paid')
        )}
        onClick={() => {
          onFilterChange('paid')
        }}
        disabled={!hasPaidCycles}>
        {t('billing.cycle-list.title-paid')}
      </Button>
    </div>
  )
}

export default BillingCycleFilter
